import {
    GET_THEMES_LIST_FAILED,
    GET_THEMES_LIST_START,
    GET_THEMES_LIST_SUCCESS
} from '../../../constants';
import { GET_THEMES_LIST } from '../../../../../config/constants';
import { ApiBase } from '../../../../utils/apiBase';
import { withType } from '../../../../utils/actionOperations';
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const getThemesList = (payload) => {
    const apiBaseInstance = new ApiBase();
    return dispatch => {
        dispatch(withType(GET_THEMES_LIST_START, {}));
        apiBaseInstance.instance
            .post(GET_THEMES_LIST, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then(response => {
                dispatch(withType(GET_THEMES_LIST_SUCCESS, {
                    data: response.data,
                    message: response.message
                }));
            })
            .catch(err => {
                dispatch(withType(GET_THEMES_LIST_FAILED, {
                    error: err
                }));
            });
    };
};

